var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.549 34.719C13.22 43.244-4.077 29.218.875 13.063 2.25 8.608 5.225 4.84 9.21 2.507a18.112 18.112 0 0 1 13.18-2.04C38.495 4.062 42.048 26.09 27.548 34.72z",
    fill: "url(#3mi4y593ya)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.547 34.719a18.135 18.135 0 0 1-9.465 2.513 18.147 18.147 0 0 1-9.392-2.783 18.507 18.507 0 0 1-6.645-7.285 18.838 18.838 0 0 1-2.008-9.716c0 4.935 1.932 9.668 5.372 13.158a18.208 18.208 0 0 0 12.968 5.45c4.864 0 9.53-1.96 12.969-5.45a18.747 18.747 0 0 0 5.371-13.158c.209 3.46-.54 6.91-2.16 9.961a18.487 18.487 0 0 1-7.01 7.31z",
    fill: "#EC9C0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.133 6.33a1.14 1.14 0 0 1-1.146.243A21.614 21.614 0 0 0 12.445 8.17a22.027 22.027 0 0 0-7.023 6.541 22.405 22.405 0 0 0-3.619 8.948 1.17 1.17 0 0 1-.27.567c-.14.16-.32.278-.521.34a17.146 17.146 0 0 1-.86-3.954C1.892 14.516 5.89 9.341 11.305 6.17A23.905 23.905 0 0 1 29.21 3.596a17.705 17.705 0 0 1 2.923 2.733z",
    fill: "#EC9C0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.26 22.693a17.253 17.253 0 0 1-1.284 3.803 1.151 1.151 0 0 1-.486-.418 1.175 1.175 0 0 1-.19-.617c-.138-4.303-2.408-8.141-4.482-9.49-7.67-5.14-12.243-5.618-13.916-9.432a4.849 4.849 0 0 1 .114-4.746 5.477 5.477 0 0 1 2.11-1.79 17.545 17.545 0 0 1 4.264.453c-.046.23-.159.441-.324.605a1.14 1.14 0 0 1-.605.314c-1.375.22-3.381.826-3.76 2.175a2.762 2.762 0 0 0 0 1.267c.952 3.56 5.285 3.803 13.354 9.2a14.247 14.247 0 0 1 5.205 8.676zM16.808 37.15a17.483 17.483 0 0 1-3.874-.78 14.234 14.234 0 0 1-4.815-8.885c-.527-8.665.975-12.991-.504-15.468-1.146-1.931-2.934-2.454-5.48.686a1.13 1.13 0 0 1-1.26.36A17.805 17.805 0 0 1 2.64 9.086a4.37 4.37 0 0 1 2.989-.951 4.384 4.384 0 0 1 2.857 1.3c3.645 3.698 1.307 7.548 1.926 17.91.149 2.512 2.292 6.409 5.857 8.677.187.116.337.284.432.484.096.2.133.423.107.644zM28.521 34.114c-.64.428-1.307.817-1.994 1.163C2.925-6.243 14.1 13.447 8.232 3.107a18.941 18.941 0 0 1 1.995-1.162l18.294 32.17z",
    fill: "#EC9C0D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.463,
    cy: 31.223,
    rx: 13.537,
    ry: 13.777,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m25.852 35.816 3.844 5.238-.33 1.987c-1.688-1.165-2.86-2.156-3.514-2.973-.655-.818-1.29-2.08-1.903-3.786l1.903-.466zM37.742 36.334l6.146-.519 2.122 5.24-2.762 2.393-2.626.95-4.163-2.236 1.283-5.828zM27.025 25.096l5.185-3.577 3.69 2.683-2.241 5.752H27.98l-.956-4.858zM43.734 24.15l1.054-3.951c1.754 1.693 2.939 3.08 3.554 4.161.614 1.08 1.167 2.747 1.658 4.997h-3.987l-2.279-5.206z",
    fill: "#2D344B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.95 24.334h13.537",
    stroke: "#2D344B",
    strokeWidth: 0.275,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m29.695 24.334 6.701-6.82M30.187 25.253l-5.527-.244",
    stroke: "#2D344B",
    strokeWidth: 0.275,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m43.228 38.112 4.513-13.778M27.443 40.408l11.282 2.296M29.695 24.334l9.025 13.778M29.692 24.334 25.18 38.112",
    stroke: "#2D344B",
    strokeWidth: 0.275,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3mi4y593ya",
    x1: 18.343,
    y1: 0.017,
    x2: 18.343,
    y2: 37.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsDark);
export default __webpack_public_path__ + "static/media/sports-dark.df22080896eda739914a50b7c771472c.svg";
export { ForwardRef as ReactComponent };